export const AI_DISCLAIMER_COPY = {
  output: 'Generato da AI. Verifica personalmente queste informazioni.',
  trigger:
    'Analisi generate tramite intelligenza artificiale. Verifica i risultati prima di utilizzarli.',
  pdfNotice:
    'Contenuto generato da intelligenza artificiale. Verifica personalmente queste informazioni.',
  // Machine-readable file property. Keep in sync with backend.utils.ai_generated_document.
  metadataKeyword: 'AI-generated',
};
